<script>
	import formBase from '@_system/components/base/form.vue'
	import invoicebox from '@/components/formcomponents/common/box/invoice/index.vue'
	import invoiceConfig from '@/components/reports/reconciliationbankflow/lib/invoice/index.vue'
	export default {
		extends: formBase,
		name: 'supplierinvoiceForm',
		props: {

		},
		data() {
			return {
				supplierinvoiceinvoiceHandle:null,
				buyerName:null,
				suplierName:null,
				invoicedata:[]
			}

		},
		render(h) {
			this.$slots.plug = [
				<invoiceConfig ref="invoiceConfig" invoicedata={this.invoicedata} tab={['invoice']} title="发票预览" />	,
				<invoicebox ref = "invoicebox"
				onBack = {
					this.invoiceboxBack
				}
				onSubmit = {
					this.invoiceboxSubmit
				}
				onBoxdataload = {
					this.invoiceboxdataload
				}
				buyerName  = {this.buyerName}
				suplierName  = {this.suplierName}
				/>
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			invoiceboxBack(){
				
			},
			invoiceboxSubmit(e){
				let data = e.data.map((item)=>{
					return {
						invoiceno:item.invoiceNumber,
						invoicetime:item.bizDate,
						buyer:item.buyerName,
						saler:item.suplierName,
						amount:item.totalPrice,
						customerId_system:item.customerId,
						invoiceId_system:item.invoiceId,
						invoiceType_system:item.invoiceType,
						invoice_file:[]
					}					
				})
				//console.log(this.supplierinvoiceinvoiceHandle)
				this.supplierinvoiceinvoiceHandle.obj = data
				this.supplierinvoiceinvoiceHandle.next()
				//console.log(e)
			},
			invoiceboxdataload(){
				
			},
			tableAdd(e){
				let $son_supplierinvoice_payment = this.fApi.el('$son_supplierinvoice_payment')
				let fullData = $son_supplierinvoice_payment.getTableData().tableData
				if(!fullData.length){
					this.$message.error('付款单据不存在')
					return
				}
				this.buyerName = fullData[0].accName
				this.suplierName = fullData[0].rcvName
				this.$nextTick(()=>{
					this.$refs.invoicebox.initList()
					this.$refs.invoicebox.box.alertBox()
				})
				this.supplierinvoiceinvoiceHandle = e
				this.$nextTick(()=>{
					this.computeAmount()
				})
			},
			afterTableInsert(e) {
				if(e.moduleName == 'supplierinvoice_payment'){
					e.obj.row.writeoffamount = e.obj.row.remainamount
				}
				this.computeAmount()
				//this.supplierinvoiceinvoiceHandle = e
				//e.obj.paymenttime = e.data.paymenttime
				
			},
			supplierwlnidChange(){
				let $son_supplierinvoice_payment = this.fApi.el('$son_supplierinvoice_payment')
				if ($son_supplierinvoice_payment.store.box) {
					let supplierwlnid = this.fApi.getValue('supplierwlnid')
					if (supplierwlnid) {
						$son_supplierinvoice_payment.store.box.add.setForeingKey({
							supplierwlnid: supplierwlnid
						})						
					}
				}
			},
			beforeInit(next) {
				next()
			},

			tablefieldChange() {
				this.computeAmount()
				// switch (e.moduleName) {
				// 	case 'supplierinvoice_invoice':
				// 		if (e.data.column.field == 'invoice_file') {
				// 			// e.data.row.amount = 100
				// 			//console.log(e.data.row.invoice_file[0].path)
				// 			this.loading = true
				// 			this.$api.supplierinvoice.OCRinvoice({invoicefilepath:e.data.row.invoice_file[0].path}).then((res)=>{
				// 				if(res){
				// 					e.data.row.invoiceocr = res
				// 					e.data.row.invoiceno = res['发票号码']
				// 					e.data.row.invoicetime = this.$Moment(res['开票日期'], 'YYYY年MM月DD日').valueOf()
				// 					e.data.row.buyer = res['受票方名称']
				// 					e.data.row.saler = res['销售方名称']
				// 					e.data.row.amount = res['发票金额']
				// 				}
				// 				this.loading = false
				// 				this.computeAmount()
				// 			},()=>{
				// 				this.loading = false
				// 				this.computeAmount()
				// 			})
				// 		}						
				// 		break;
				// 	case 'supplierinvoice_payment':
				// 		if (e.data.column.field == 'writeoffamount') {
				// 			e.data.row.writeoffamount = Math.min(e.data.row.remainamount, e.data.row.writeoffamount)
				// 			this.computeAmount()
				// 			//console.log(e)
				// 		}
				// 		break;
				// }
			},
			aftertabledelete() {
				this.computeAmount()
			},
			regestEvent() {
				//console.log(this.extra)
				if (this.extra.supplierwlnids) {
					this.$api.supplier.list({
						mode: 'box',
						index: 0,
						wlnid: this.extra.supplierwlnids
					}).then((res) => {
						this.setQuoteData({
							data: res.list[0],
							moduleName:'supplier'
						})
						//console.log(res)
					})
				}
				if (this.extra.purchasecodes) {
					let $son_supplierinvoice_payment = this.fApi.el('$son_supplierinvoice_payment')
					this.$api.paymentapplication.list({
						mode: 'box',
						index: 0,
						purchasecode: this.extra.purchasecodes
					}).then((res) => {
						$son_supplierinvoice_payment.add({
							data: res.list
						})

						//console.log(res)
					})
				}
				
				let $son_supplierinvoice_invoice = this.fApi.el('$son_supplierinvoice_invoice')
				$son_supplierinvoice_invoice.notice = `
					<span style="color:#F56C6C";>发票同步延迟1-2小时</span>		
				`
				$son_supplierinvoice_invoice.preview = this.preview
				
			},
			preview(row){
				//console.log(row)
				this.invoicedata = {
					invoiceNumber:row.invoiceno,
					customerId:row.customerId_system,
					invoiceId:row.invoiceId_system,
					invoiceType:row.invoiceType_system
				}
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			computeAmount() {
				let $son_supplierinvoice_invoice = this.fApi.el('$son_supplierinvoice_invoice')
				console.log($son_supplierinvoice_invoice.getTableData())
				let fullData = $son_supplierinvoice_invoice.getTableData().fullData
				let amount = 0
				fullData.forEach((item) => {
					amount += !isNaN(parseFloat(item.amount)) ? parseFloat(item.amount) : 0
				})
				this.fApi.setValue('invoicenum', fullData.length)
				this.fApi.setValue('invoiceamount', amount.toFixed(2))


				let $son_supplierinvoice_payment = this.fApi.el('$son_supplierinvoice_payment')
				fullData = $son_supplierinvoice_payment.getTableData().fullData
				let writeoffamount = 0
				fullData.forEach((item) => {
					writeoffamount += !isNaN(parseFloat(item.writeoffamount)) ? parseFloat(item.writeoffamount) : 0
				})
				this.fApi.setValue('writeoffamount', writeoffamount.toFixed(2))
				
				this.fApi.setValue('diffamount', (amount - writeoffamount).toFixed(2))

			},
		},
		components: {
			invoicebox,
			invoiceConfig
		}
	}
</script>